function ExternalLinkIcon(props) {
  return (
    <svg
      height="100px"
      width="100px"
      fill="#0079ff"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      {...props}
    >
      <path d="M28.8,84.1h36c7.2,0,13-5.8,13-13V49.1c0-1.7-1.3-3-3-3h0c-1.7,0-3,1.3-3,3v22c0,3.9-3.1,7-7,7h-36c-3.9,0-7-3.1-7-7V37.2c0-3.9,3.1-7,7-7h22c1.7,0,3-1.3,3-3s-1.3-3-3-3h-22c-7.2,0-13,5.8-13,13v33.9C15.8,78.3,21.6,84.1,28.8,84.1z" />
      <path d="M84.2,37.2V18.9c0-0.2,0-0.4-0.1-0.6c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.3-0.5-0.6-0.8-0.8l-0.2-0.1c-0.2-0.1-0.4-0.1-0.6-0.1h-18.5c-1.7,0-3,1.3-3,3s1.3,3,3,3h11.1L46.4,49.4c-1.2,1.2-1.2,3.1,0,4.2c1.2,1.2,3.1,1.2,4.2,0l27.6-27.5v11.1c0,1.7,1.3,3,3,3h0c1.7,0,3-1.3,3-3V37.2C84.1,37.2,84.2,37.2,84.2,37.2z" />
    </svg>
  )
}

export default ExternalLinkIcon
